import { useSelector } from 'react-redux';
import Logger from '../services/Logger';
import { isNativeSelector } from '../redux/reducers/app/params';
import { SERVICE_NAME } from '../constants';
import { DATA_LAYER_EVENT, DATA_LAYER_EVENT_CATEGORY } from '../constants/ga';

export const dataLayerEventLogger = new Logger(
  `${SERVICE_NAME}:dataLayerEvent`,
  {
    prefixColor: '#6540b5',
  }
);

// Google Optimize как-то по особенному манки-патчит функцию push в datalayer и добавляет спец аттрибуты
export function gtag() {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
  } catch (e) {
    dataLayerEventLogger.log('dataLayer.push throws an error during gtag');
  }
}

export function pushToDataLayer(event) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
  } catch (e) {
    dataLayerEventLogger.log(
      'dataLayer.push throws an error during pushing event'
    );
  }
}

export function trackFirstOpen(serviceName) {
  const currentDay = new Date().toDateString();
  const key = `${serviceName}_first-open-tracker`;
  const lastOpenDay = localStorage.getItem(key);

  if (lastOpenDay === currentDay) return;

  pushToDataLayer({ event: 'first_open' });

  localStorage.setItem(key, currentDay);
}

// SOURCE: https://firebase.google.com/docs/analytics/webview?platform=ios
export function logNativeEvent({ name, params }) {
  if (!name) {
    return;
  }

  if (window.AnalyticsWebInterface) {
    // Call Android interface
    window.AnalyticsWebInterface.logEvent(name, JSON.stringify(params));
  } else if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.firebase
  ) {
    // Call iOS interface
    var message = {
      command: 'logEvent',
      name: name,
      parameters: params,
    };
    window.webkit.messageHandlers.firebase.postMessage(message);
  } else {
    // No Android or iOS interface found
    console.log(
      `Firebase analytics interface not found. Skip logging event: ${name}`
    );
  }
}

const NATIVE_MODE = 'NATIVE';
const WEB_MODE = 'WEB';

export function analyticsLog(data, isNative = false) {
  const mode = isNative ? NATIVE_MODE : WEB_MODE;

  if (!data || !data.event || !data.eventCategory || !data.eventAction) {
    dataLayerEventLogger.warn(
      `${mode} (FAILURE):\n`,
      'Analytics event without required fields:\n',
      data
    );
  }

  if (isNative) {
    logNativeEvent({
      name: data.eventAction,
      params: data,
    });
  } else {
    pushToDataLayer(data);
  }

  dataLayerEventLogger.log(`${mode}:\n\n`, data);
}

export const useAnalytics = (
  event = DATA_LAYER_EVENT,
  eventCategory = DATA_LAYER_EVENT_CATEGORY
) => {
  const isNative = useSelector(isNativeSelector);

  return (data) => analyticsLog({ event, eventCategory, ...data }, isNative);
};
